import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ResourceType } from '../types/resource-item.class';
import { isContentTypeEnabled } from './content-types';

/**
 * Keeps a direct URL from reaching a type this build does not offer: a shared
 * link, a bookmark in the browser, a card in an old push notification. The page
 * itself is untouched and comes back the moment the type is switched on again.
 */
export function contentTypeEnabledGuard(type: ResourceType): CanActivateFn {
    return () => isContentTypeEnabled(type) ? true : inject(Router).createUrlTree(['/home']);
}
